module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"onfield_service_part.field.claim.num_request":"ขอเคลม","onfield_service_part.field.remark_claim":"หมายเหตุเคลม","onfield_service_part.field.remark_claim.placeholder":"รายละเอียดขอเคลม","onfield_service_part.part_detail":"SKU : {sku}","onfield_service_part.part.unit":"{count} ชิ้น","onfield_service_part.part.claim.unit":"{count} ชิ้น"}}')
  delete Component.options._Ctor
}
